(function () {
  var chromeObserver = null;

  function measureChrome() {
    var hero = document.querySelector('.trinsic-hero');
    if (!hero) return;
    var top = Math.round(hero.getBoundingClientRect().top + window.scrollY);
    if (top < 0) top = 0;
    document.documentElement.style.setProperty('--trinsic-chrome-height', top + 'px');
  }

  function bindChrome() {
    measureChrome();
    var raf;
    function schedule() {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(measureChrome);
    }
    window.addEventListener('resize', schedule);
    window.addEventListener('load', schedule);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(schedule);
    }
    setTimeout(schedule, 250);
    setTimeout(schedule, 1000);
    if ('ResizeObserver' in window) {
      if (chromeObserver) chromeObserver.disconnect();
      chromeObserver = new ResizeObserver(schedule);
      chromeObserver.observe(document.body);
    }
  }

  function initSlider(container) {
    var track = container.querySelector('.trinsic-hero__track');
    var slides = container.querySelectorAll('.trinsic-hero__slide');
    if (!track || slides.length <= 1) return;

    var dots = container.querySelectorAll('.trinsic-hero__dot');
    var prevBtn = container.querySelector('[data-direction="prev"]');
    var nextBtn = container.querySelector('[data-direction="next"]');
    var total = slides.length;
    var currentIndex = 0;
    var autoplay = container.dataset.autoplay === 'true';
    var speed = parseInt(container.dataset.speed, 10) * 1000 || 5000;
    var interval;

    function setIndex(index) {
      currentIndex = index;
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    function goTo(index) {
      if (index < 0) index = total - 1;
      if (index >= total) index = 0;
      setIndex(index);
      track.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
    }

    // The track is finger-swipeable at ≤749px (overflow-x: auto + scroll snap),
    // so the index has to be re-derived from scroll position — otherwise the dots
    // and the autoplay timer keep counting from wherever the last arrow click
    // left them and fight the swipe.
    function syncFromScroll() {
      var nearest = 0;
      var closest = Infinity;
      slides.forEach(function (slide, i) {
        var delta = Math.abs(slide.offsetLeft - track.scrollLeft);
        if (delta < closest) {
          closest = delta;
          nearest = i;
        }
      });
      if (nearest !== currentIndex) setIndex(nearest);
    }

    if ('onscrollend' in window) {
      track.addEventListener('scrollend', syncFromScroll);
    } else {
      var scrollSync;
      track.addEventListener('scroll', function () {
        clearTimeout(scrollSync);
        scrollSync = setTimeout(syncFromScroll, 120);
      }, { passive: true });
    }

    function startAutoplay() {
      if (autoplay && total > 1) {
        interval = setInterval(function () { goTo(currentIndex + 1); }, speed);
      }
    }

    function resetAutoplay() {
      clearInterval(interval);
      startAutoplay();
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(currentIndex - 1); resetAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(currentIndex + 1); resetAutoplay(); });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(this.dataset.index, 10));
        resetAutoplay();
      });
    });

    // Hold the timer while a finger is down, then restart it from the slide the
    // swipe landed on — an autoplay tick mid-swipe would yank the track away.
    track.addEventListener('touchstart', function () { clearInterval(interval); }, { passive: true });
    track.addEventListener('touchend', resetAutoplay, { passive: true });

    startAutoplay();
  }

  function init() {
    bindChrome();
    document.querySelectorAll('.trinsic-hero').forEach(function (container) {
      initSlider(container);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    bindChrome();
    var target = event.target;
    var hero = target && target.querySelector ? target.querySelector('.trinsic-hero') : null;
    if (hero) initSlider(hero);
  });
})();
